import { render } from "./ConfirmationModal.vue?vue&type=template&id=e1a163e6"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__